<template>
  <div class="productFileterPc d-md-block d-none" :class="{'athena-filter':theme==='athena'}">
    <div class="pc-header">
      <header>
        <h5 class="title_font">{{$t('filter.refine_by')}}</h5>
        <button @click="clearFilter" class="page_text_font">{{$t('filter.clear_all')}}</button>
      </header>
      <v-checkList
        :payload="payload"
        :fake_payload="fake_payload"
      ></v-checkList>
      <div @click="clearFilter" class="athena_clear_btn" v-if="theme == 'athena'">
        <span>
            {{$t(`filter${theme && theme=='athena'?'.athena':''}.clear_all`)}}
        </span>
      </div>
    </div>
    <template v-for="(item, index) in product_filter.items">
      <div class="filter-wrap" v-if="item.status&&item.status===true" :key="item.type + index">
        <v-collapse-card
          :title="item.title"
          :collapse_key="item.id + item.type + index"
          :default_show="!item.list_collapse"
          :toggle_style="{ paddingBottom: 0 }"
        >
          <v-filterIndex :filterItem="item" :payload="payload"></v-filterIndex>
        </v-collapse-card>
      </div>
    </template>
  </div>
</template>
<script>
import vCollapseCard from "../../common/collapseCard";
import vFilterIndex from "./filterIndex";
import vCheckList from "./checkList";
export default {
  props: ["product_filter", "payload", "fake_payload", "theme"],
  data() {
    return {};
  },
  methods: {
    clearFilter() {
      let payload = {};
      for (const key in this.payload) {
        payload[key] = [];
      }
      this.bus.$emit("changeFilter", payload);
    },
  },
  components: {
    vCollapseCard,
    vFilterIndex,
    vCheckList,
  },
};
</script>
<style scoped lang='scss'>
button {
  border: none;
  background-color: transparent;
}
.productFileterPc {
  .pc-header {
    margin-bottom: 15px;
    & > header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      h5 {
        color: #606266;
        font-size: 14px;
      }
    }
  }
  .filter-wrap {
    margin-bottom: 32px;
  }
  .filter-wrap::v-deep .collapseCard {
    border-bottom: none;
    .collapseCardTitle {
      line-height: 23px;
      margin-bottom:16px;
      & > h5 {
        font-size: 14px;
        // font-family: 'Muli-Bold'!important;
        font-weight: 700;
        letter-spacing: 1px!important;
        color: #333;
      }
    }
    .arrows-top {
      margin-top: 7px;
    }
    .arrows-bottom {
      margin-top: 0;
    }
  }
}
.athena-filter {
  .pc-header {
     margin-bottom: 40px;
  }
  .filter-wrap {
     margin-bottom: 30px;
  }
  header {
     button {
       display: none;
     }
  }
  .athena_clear_btn {
   height: 48px;
   display: flex;
   justify-content: center;
   align-items: center;
   border: 1px solid #222A40;
   cursor: pointer;
   margin-top: 30px;
   font-size: 16px;
  }
 .filter-check-list {
  border-bottom: 1px solid #EAEAEA;
  padding-bottom: 23px;
  }
 .filter-wrap:not(:last-child) {
   border-bottom: 1px solid #EAEAEA;;
 } 
 .filter-wrap::v-deep .collapseCard {
    .collapseCardTitle {
      margin-bottom: 30px;
      padding-top: 0;
      > h5 {
        font-size: 20px;
        // font-family: 'Roboto' !important;
      }
    }
    .filter-section-content {
      margin-bottom: 20px;
      a {
        line-height: 16px;
        font-size: 16px;
      }
      span {
         line-height: 16px;
         font-size: 16px;
      }
    }
 }
 & ::v-deep {
   .filter-color .color-slider{
     .el-checkbox-group label {
       width: 50% !important;
       flex-wrap: nowrap;
       margin-bottom: 14px !important;
     }
     .el-checkbox-group .half-circle {
       left:15px !important
     }
     .el-checkbox__input {
       width: 30px !important;
     }
     .el-checkbox__label {
       width: 80% !important;
       line-height: 30px !important;
       > span:first-child {
         white-space: nowrap !important;
         text-overflow: ellipsis;
         overflow: hidden;
         display: block;
         padding: 0 5px 0 11px;
         text-align: left;
       }
     }
     .el-checkbox__input::after {
       left: 42% !important;
     }
   }  
   .filter-color .color-list {
     .el-checkbox-group label {
       margin-bottom: 12px;
       font-family: 'Roboto';
       .el-checkbox__label {
         font-size: 16px;
         padding-left: 14px;
       }
     }
   }
   .view-more {
     font-weight: bold;
     font-size: 16px;
     text-decoration: underline;
     margin-bottom: 30px;
     color: #222A40;
   }
   .el-checkbox__label {
     font-size: 16px !important;
   }
   .filter-price-slider {
     .input-min-max {
       margin-bottom: 20px;
       .el-input {
         width: 45%;
         padding-right: 1px;
       }
       .el-input__inner {
         border-radius: unset;
         height: 38px !important;
         line-height: 38px !important;
       }
     }
     .el-slider__runway {
       background-color: #ccc !important;
       .el-slider__stop {
         height: 0 !important;
       }
       .el-slider__button {
         border: 1px solid #222A40;
       }
     }

   }
 }
}
</style>